import React__default, { useState, useCallback, useEffect } from 'react';
import classNames from 'classnames';
import debounce from 'lodash.debounce';
import Styles from './SearchField.module.scss.js';
import { ReactComponent as SvgSearch } from '../../icons/Search.svg.js';

const SearchField = ({ placeholder, onChange, style, searchWrapperClass, value, enableDebounce = false, debounceDuration = 500, limit }) => {
    const [searchString, setSearchString] = useState("");
    const handleSearchFilter = (e) => {
        if (e.target.value === "") {
            setSearchString("");
            onChange("");
        }
        else {
            setSearchString(e.target.value);
        }
    };
    const onSearchKeyDown = (e) => {
        if (e.key === "Enter") {
            e.target.blur();
            return;
        }
    };
    // Search Debounce
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const delayedQuery = useCallback(debounce(() => onChange(searchString), debounceDuration), [searchString]);
    useEffect(() => {
        if (searchString !== "") {
            delayedQuery();
        }
        return delayedQuery.cancel;
    }, [searchString, delayedQuery]);
    // useEffect(() => {
    //     if (enableDebounce) {
    //         setSearchString(value);
    //     }
    // }, [value]);
    // Added & Commented By Sudhanshu
    return (React__default.createElement("div", { className: classNames(Styles.searchFieldWrapper, searchWrapperClass), style: Object.assign({}, style) },
        React__default.createElement("div", { className: classNames(Styles.inputWrapper) },
            React__default.createElement("input", { type: "text", placeholder: placeholder, onChange: enableDebounce ? handleSearchFilter : onChange, value: enableDebounce ? searchString : value, onKeyDown: onSearchKeyDown, maxLength: limit }),
            React__default.createElement("div", { className: classNames(Styles.iconWrapper) },
                React__default.createElement(SvgSearch, null)))));
};

export { SearchField as default };
//# sourceMappingURL=SearchField.js.map
